import React, { useEffect } from 'react';

import {
    useHistory
} from "react-router-dom";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from "@material-ui/core/styles";

import CoupleAvatar from '../CoupleAvatar';
import CoupleProfileForm from '../CoupleProfileForm';


const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    paperWrapper: {
        maxWidth: 1024,
        margin: '10px auto',
        '& p': {
            marginBottom: theme.spacing(2)
        }
    }
}));

const CoupleProfile = (props) => {
    const {
        couple,
        setCouple,
    } = props;

    const classes = useStyles();

    useEffect(() => {
        document.title = 'Profile - Enduring Promises';
    });

    let history = useHistory();

    const handleBackClick = () => {
        history.push('/couple')
    };

    const provinces = window.provinces;

    return (
        <div className={classes.paperWrapper}>
            <Paper square className={classes.paper}>
                <Typography variant="h5" component="h2" color="textPrimary" gutterBottom={true}>
                    Edit your Profile
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container justify="center" alignItems="center">
                            <CoupleAvatar couple={couple} setCouple={setCouple} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <CoupleProfileForm couple={couple} provinces={provinces} setCouple={setCouple} />
                    </Grid>
                </Grid>
            </Paper>
            <Box mt={2}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleBackClick}
                    endIcon={<Icon>chevron_right</Icon>}
                >
                        View Ceremony
                </Button>
            </Box>
        </div>
    )
};


export default CoupleProfile;